module.exports = __webpack_public_path__ + "static/img/news@2x1.c70cf033.png";